import { render } from "./Vraag.vue?vue&type=template&id=d96ad532&scoped=true"
import script from "./Vraag.vue?vue&type=script&lang=js"
export * from "./Vraag.vue?vue&type=script&lang=js"

import "./Vraag.vue?vue&type=style&index=0&id=d96ad532&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d96ad532"

export default script